import { StripeCardCvcElementChangeEvent, StripeError } from "@stripe/stripe-js";
import TextField, { TextFieldProps } from "@powerdiary/components-library/lib/components/Controls/TextField";
import { CardCvcElementProps, CardCvcElement } from "@stripe/react-stripe-js";
import StripeInput from "../StripeInput";

export type StripeCardCvcTextFieldProps = { onChange?: (e: StripeCardCvcElementChangeEvent) => void } & Omit<
    TextFieldProps,
    "onChange"
> &
    CardCvcElementProps;

export default function StripeCardCvcTextField({
    children,
    InputProps,
    InputLabelProps,
    size = "medium",
    onChange,
    options,
    onReady,
    ...restProps
}: StripeCardCvcTextFieldProps) {
    return (
        <TextField
            {...restProps}
            size={size}
            variant="outlined"
            slotProps={{
                input: {
                    ...InputProps,
                    inputComponent: StripeInput,
                    inputProps: {
                        component: CardCvcElement,
                        options: options,
                        onReady: onReady,
                        onChange: onChange as unknown as TextFieldProps["onChange"],
                        onLoadError: (error: StripeError) => {
                            console.error("Stripe Element failed to load", error);
                        },
                    },
                },
                inputLabel: {
                    ...InputLabelProps,
                    shrink: true,
                },
            }}
        >
            {children}
        </TextField>
    );
}
